import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'opc-provider-card',
  name: '服务商卡片',
  icon: '商',
  group: 'OPC 业务组件',
  description: '展示认证服务商卡片（静态配置，评分与完成数由运营在编辑器填写；服务商详情读取随后续列表端点交付再绑定数据源）。',
  defaultProps: {
    title: '认证服务商',
    showRating: true,
    showCompletedCount: true
}
}
